import accountNoFilter from './accountNoFilter'
import amountFilter from './amountFilter'
import typeofCard from './bankCardType'
import cardMask from './bankCardMask'
import cardMaskFirst from './bankCardMaskFirst'
import formatMoney from './formatMoney'
import dateConvertFilter from './dateConvertFilter'
import dimAcNoFilter from './dimAcNoFilter'
import dimAcNoFilter2 from './dimAcNoFilter2'
import percent from './percent'
import phoneNumFilter from './phoneNumFilter'
import timestampToDateFtr from './timestampToDateFtr'
import { amountTwoFtr, showDay, MonthToUpper } from './other'
import { jsonFilter, limitToFilter, orderByFilter, lowercase, uppercase } from './common'
import rateFilter from "./rate"

const filters = {
  timestampToDateFtr,
  accountNoFilter,
  amountFilter,
  dateConvertFilter,
  dimAcNoFilter,
  dimAcNoFilter2,
  percent,
  phoneNumFilter,
  amountTwoFtr,
  showDay,
  MonthToUpper,
  jsonFilter,
  limitToFilter,
  orderByFilter,
  lowercase,
  uppercase,
  typeofCard,
  formatMoney,
  cardMask,
  cardMaskFirst,
  rateFilter,
};

export default filters



// WEBPACK FOOTER //
// ./src/modules/filter/index.js